import type { QueryClient } from "@tanstack/react-query";
import { authSessionQueryKey } from "./query-keys";

export function clearAuthenticatedQueries(queryClient: QueryClient) {
  queryClient.removeQueries({
    predicate: (query) => query.queryKey[0] !== authSessionQueryKey[0],
  });
  queryClient.setQueryData(authSessionQueryKey, false);
}
